var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListdiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: -1,
    width: 10,
    height: 10,
    rx: 3,
    transform: "rotate(45 6.07031 -1)",
    fill: "#4565B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListdiamond);
export default __webpack_public_path__ + "static/media/listdiamond.d304b863697b06cfaf1a2b05199ab54b.svg";
export { ForwardRef as ReactComponent };